import * as yup from "yup";

const imageUrlSchema = yup.string().url();

const imageObjectSchema = yup.object({
  type: yup.string().required(),
  src: yup.string().url().required(),
  webp: yup.string().url().notRequired(),
});

export const imageSchema = yup.mixed().test((value) => {
  if (!value) return true; // Allow null/undefined (optional

  if (typeof value === "string") {
    return imageUrlSchema.isValidSync(value);
  } else {
    return imageObjectSchema.isValidSync(value);
  }
});

export type TImage =
  | yup.InferType<typeof imageUrlSchema>
  | yup.InferType<typeof imageObjectSchema>;

export type TImageObject = yup.InferType<typeof imageObjectSchema>;
